<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21 16"  xml:space="preserve">
        <polygon points="14,0 8,13.001 5,7 0,16 5,10 8,14 14,5 20.999,16 "/>
    </svg>
</template>

<script>
export default {
    name: 'IconRef',
}
</script>

<style lang="scss" scoped>
</style>